import * as yup from 'yup';

export const settingsSchema = yup.object({
  highlightRisikoDEMVer: yup.boolean().default(true).required(),
  bewertungsart: yup
    .string()
    .oneOf(['stars', 'default'])
    .default('default')
    .required(),
  gesamtaufwand: yup.boolean().default(false).required(),
});

export type Settings = yup.Asserts<typeof settingsSchema>;
